import Link from 'next/link';

import Styles from '@components/header-form/style';

export default function HeaderForm() {
  return (
    <Styles.MainHeader>
      <Styles.WrapperHeader>
        <Styles.Back>
          <Link href="/">
            <img src="/images/ico-back-hover.svg" width="8" height="13" alt="voltar para home" />
          </Link>
        </Styles.Back>
        <Styles.LinkLogo href="/">
          <Styles.Logo>
            <img src="/images/logo-wb-sm.svg" height="28" alt="Login - whitebook" />
          </Styles.Logo>
        </Styles.LinkLogo>
      </Styles.WrapperHeader>
    </Styles.MainHeader>
  );
}
